export default __webpack_public_path__ + "static/media/mdFace.550f163a.png";